const label = "text-sm py-1 flex items-center font-semibold";
const inputStyle = 'rounded-xl px-4 py-3 outline-none border-none bg-customTwo w-full my-1 text-sm placeholder:font-light';

const title = 'text-lg font-semibold text-gray-800';
const subTitle = 'text-md font-semibold text-gray-800 py-2'
const modalTitle = title + ' ' + 'text-center'
const modalContainer = "flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-screen w-screen bg-opacity-60 z-[99]";
const loaderContainer = "flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-screen w-screen bg-opacity-60 z-[1000]"

const textAreaStyle = 'border rounded-md h-32 w-full mx-2 border-green-200 outline-green-300 p-2 text-gray-400 font-medium';
const smallTextAreaStyle = 'border rounded-md h-12 w-full mx-2 border-green-200 outline-green-300 p-2 text-gray-400 font-medium';
const optionStyle = 'bg-gray-200 text-green-500 py-2';
const tableStyle = 'table-auto w-full';
const tableHeader = 'px-4 py-2 bg-customTwo text-sm font-semibold py-5';
const tableData = 'px-4 py-8 text-left text-sm';

const btnOne = 'w-full border border-customOne rounded-lg py-2 px-6 text-center text-sm text-white bg-customOne font-semibold cursor-pointer'
const btnOneLight = 'flex items-center border border-customOne rounded-xl p-1 px-4 text-center text-sm text-white bg-customOne opacity-50 hover:opacity-70 cursor-pointer'
const btnTwo = 'w-full border border-customOne rounded-lg p-2 text-center text-customOne font-semibold cursor-pointer'
const btnSmallTwo = 'border border-customOne rounded-lg py-2 px-6 text-center text-sm text-gray-200 bg-customOne flex gap-2 items-center cursor-pointer'
const btnCancel = 'w-full border border-customThree rounded-lg p-2 px-6 text-center text-white bg-customThree font-semibold cursor-pointer'
const btnSmall = 'border border-customOne rounded-full py-2 px-8 text-center text-white bg-customOne font-semibold flex gap-2 items-center cursor-pointer'
const btnRound = 'bg-customTwo rounded-full p-3 cursor-pointer'
const btnWhite ='w-full rounded-lg p-2 bg-gray-100 text-sm flex items-center justify-center gap-2 cursor-pointer'
const btnRed = 'bg-red-700 py-1 px-4 rounded-full text-xs text-white mr-4 cursor-pointer'
const btnGreen = 'bg-green-700 py-1 px-4 rounded-full text-xs text-white mr-4 cursor-pointer'
const btnOneNoWidth = 'border border-customOne rounded-lg py-2 px-6 text-center text-sm text-white bg-customOne font-semibold cursor-pointer'
const tableCol = "border-b border-gray-300 text-sm p-4";

const dropDownStyle = {
    multiselectContainer: { 
        maxWidth: '16rem',
        width: '16rem',
        maxHeight: '8rem',
        border: '1px solid #bbf7d0',
        borderRadius: '4px'
    },
    inputField: { 
        fontWeight: '500'
    },
    option: {
        backgroundColor: 'rgb(229 231 235)',
        color: '#22c55e',
        hover: {
            color: 'red'
        }
    }
};

export { 
    label,
    inputStyle, 
    textAreaStyle, 
    optionStyle, 
    tableStyle, 
    tableHeader, 
    tableData,
    tableCol, 
    smallTextAreaStyle, 
    dropDownStyle,
    btnOne,
    btnOneLight, 
    btnTwo,
    btnSmall,
    btnSmallTwo,
    btnCancel,
    btnRound,
    btnWhite,
    title,
    modalTitle,
    modalContainer, 
    loaderContainer,
    btnRed,
    btnGreen,
    subTitle,
    btnOneNoWidth
};